import React, { useEffect, useState } from 'react';
import HeroSection from '../components/HeroSection';
import NewsSection from '../components/NewsSection';
import ScheduleSection from '../components/ScheduleSection';
import VideoHighlightsSection from '../components/VideoHighlightsSection';
import StatsHighlightsSection from '../components/StatsHighlightsSection';
import sanityClient from '../lib/sanityClient';
import SEO from '../components/SEO';

function HomePage() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newsItems, setNewsItems] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [featuredVideos, setFeaturedVideos] = useState([]);
  const [teamStats, setTeamStats] = useState(null);

  useEffect(() => {
    // Use Promise.all to fetch all data in parallel
    Promise.all([
      // Fetch news items
      sanityClient.fetch(
        `*[_type == "news"] | order(publishedAt desc)[0...3]{
          _id,
          title,
          "excerpt": summary,
          "image": mainImage.asset->url,
          "date": publishedAt,
          "slug": slug
        }`
      ),

      // Fetch upcoming events/games
      sanityClient.fetch(
        `*[_type == "event" && startDate > now()] | order(startDate asc)[0...4]{
          _id,
          title,
          startDate,
          location,
          eventType,
          opponent,
          isHomeGame
        }`
      ),

      // Fetch featured videos
      sanityClient.fetch(
        `*[_type == "trainingVideo" && featured == true][0...2]{
          _id,
          title,
          description,
          type,
          url,
          "thumbnailUrl": thumbnail.asset->url,
          category
        }`
      ),

      // Fetch team stats summary
      sanityClient.fetch(
        `*[_type == "teamStats"][0]{
          record,
          standingPosition,
          goalsFor,
          goalsAgainst,
          winningStreak,
          nextGame
        }`
      ),
    ])
      .then(([newsData, eventsData, videosData, statsData]) => {
        setNewsItems(newsData);
        setUpcomingEvents(eventsData);
        setFeaturedVideos(videosData);
        setTeamStats(statsData);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching homepage data:', err);
        setError('Failed to load content. Please try again later.');
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <>
        <SEO
          title="Bombardiers Hockey - Home"
          description="Follow the Bombardiers Hockey team for game schedules, player stats, team news, and training videos."
        />
        <div className="flex justify-center items-center h-64">
          <div className="text-2xl text-gray-700">Loading...</div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <SEO
          title="Bombardiers Hockey - Home"
          description="Follow the Bombardiers Hockey team for game schedules, player stats, team news, and training videos."
        />
        <div className="flex justify-center items-center h-64">
          <div className="text-xl text-red-600">{error}</div>
        </div>
      </>
    );
  }

  return (
    <>
      <SEO
        title="Bombardiers Hockey - Home"
        description="Follow the Bombardiers Hockey team for game schedules, player stats, team news, and training videos."
      />
      <HeroSection teamStats={teamStats} />
      {newsItems.length > 0 && <NewsSection newsItems={newsItems} />}
      <ScheduleSection upcomingEvents={upcomingEvents} />
      <VideoHighlightsSection videos={featuredVideos} />
      <StatsHighlightsSection stats={teamStats} />
    </>
  );
}

export default HomePage;
